import { createBrowserHistory } from "history";

const history = createBrowserHistory();
history.replace({ firstPage: true })

export default history; //createBrowserHistory();
